module.exports = __webpack_public_path__ + "static/img/loginImg.8959a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loginImg.png
// module id = 4yyA
// module chunks = 1